import styled, { css } from 'styled-components';
import { fontFamily } from 'components/styles/_variables';
import { respondTo } from '../../../../styles/_respondTo';

export const Wrapper = styled.div`
  padding: 0 20px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  ${({ isTitle }) =>
    isTitle
      ? css`
          padding: 20px 0 10px 0;
        `
      : css`
          padding: 12px 0;
        `}

  &:after {
    position: absolute;
    width: 100%;
    //background-color: #FF7828;
  }
`;

export const RowItem = styled.div`
  display: flex;
  flex: ${({ flex = 1 }) => flex};
  font-family: ${fontFamily.primary};
  color: #636262;
  justify-content: ${({ justify = 'flex-start' }) => justify};
  align-items: center;
  ${({ title = false }) =>
    title &&
    css`
      font-size: 16px;
      font-weight: 600;
      line-height: 1.5;
    `}
  ${respondTo.mobile`
    font-size: 14px;
    ${({ hiddenMobile }) =>
      hiddenMobile &&
      css`
        display: none !important;
      `}
  `}
`;

export const Delete = styled.span`
  &:disabled {
    cursor: not-allowed;
    touch-action: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      touch-action: none;
      opacity: 0.75;
    `}
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const Header = styled.div`
  padding: 16px;
  font-weight: bold;
  font-size: 18px;
  border-bottom: 1px solid #eee;
`;

export const Body = styled.div`
  padding: 16px;
  font-size: 16px;
`;

export const Footer = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
